/**
 * The common screen's words.
 *
 * `en` is the source, and `fr` is typed as covering every one of its keys, so
 * a forgotten translation is a build error rather than an English word that
 * quietly shows up in a French interface.
 */

const en = {
  // The shared primitives. A screen reader is the only one who hears this one.
  uiLoading: "loading",

  // A newer build is installed and waiting; taking it means a reload.
  updateReady: "A new version is ready",
  updateApply: "Reload",
  updateLater: "Later",

  // The door.
  authTitle: "This library is private",
  authLead: "Sign in to open it.",
  authName: "Name",
  authPassword: "Password",
  authSubmit: "Sign in",
  authChecking: "Checking...",
  authWrong: "Wrong user name or password.",
  authTooMany: "Too many attempts. Wait five minutes.",
  authLostHint: "Lost the password? It lives in the server's configuration. Set a new hash with",

  // Failures a reader sees, as opposed to the ones a console does. Each screen
  // states its own headline and puts one of the `Detail` lines under it, which
  // is why those start lower case and end without a full stop.
  errorNoServer: "The server did not answer.",
  errorNoServerDetail: "the server did not answer",
  errorBookDetail: "this book could not be opened",
  playbackRefused: "playback refused",
  playbackLoadFailed: "the audio could not be loaded",
} as const;

const fr: Record<keyof typeof en, string> = {
  uiLoading: "chargement",

  updateReady: "Une nouvelle version est prête",
  updateApply: "Recharger",
  updateLater: "Plus tard",

  authTitle: "Cette bibliothèque est privée",
  authLead: "Se connecter pour l'ouvrir.",
  authName: "Nom",
  authPassword: "Mot de passe",
  authSubmit: "Se connecter",
  authChecking: "Vérification...",
  authWrong: "Nom ou mot de passe incorrect.",
  authTooMany: "Trop de tentatives. Attendre cinq minutes.",
  authLostHint:
    "Mot de passe perdu ? Il est dans la configuration du serveur. Générer une nouvelle empreinte avec",

  errorNoServer: "Le serveur n'a pas répondu.",
  errorNoServerDetail: "le serveur n'a pas répondu",
  errorBookDetail: "ce livre n'a pas pu être ouvert",
  playbackRefused: "lecture refusée",
  playbackLoadFailed: "l'audio n'a pas pu être chargé",
};

export const common = { en, fr };
